export const ISLIVE = process.env.REACT_APP_IS_LIVE === '1'

export const BaseUrls: any = {
	API_SERVER: {
		url: ISLIVE ? process.env.REACT_APP_API_BASE_URL_LIVE : process.env.REACT_APP_API_BASE_URL_UAT
	},
}

export const REACT_APP_CDN_URL = ISLIVE ? process.env.REACT_APP_CMRF_S3_BUCKET_URL_LIVE : process.env.REACT_APP_CMRF_S3_BUCKET_URL_UAT;

export const ENC_KEY_STRING = process.env.REACT_APP_ENCRYPTION_KEY || '';
export const IV_STRING = process.env.REACT_APP_ENCRYPTION_IV || '';
export const emailUser = 'osd.cmrf'